import { render } from "./StatisticsInvoicesView.vue?vue&type=template&id=507dcfc6&scoped=true"
import script from "./StatisticsInvoicesView.vue?vue&type=script&lang=js"
export * from "./StatisticsInvoicesView.vue?vue&type=script&lang=js"

import "./StatisticsInvoicesView.vue?vue&type=style&index=0&id=507dcfc6&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507dcfc6"]])

export default __exports__